angular.module('aprima-provider-api')
    .factory('ProcedureRepository', ['AprimaRestangular', function (aprimaRestangular) {
        'use strict';

        var getProcedures = function (searchString) {
        	var queryString = '?maxRecords=20&procedureText=' + searchString;

            return aprimaRestangular.get().all('procedures/' + queryString).getList();
        };

        return {
            getProcedures: getProcedures
        };

    }]);